import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ColorPicker from "../../../common/components/Select/ColorPicker/ColorPicker";
import { createStyles, palette } from "../../../styles/theme";

const styles = createStyles({
  displayCellButton: {
    minHeight: 45,
    height: 45,
    minWidth: 88,
    px: 0.75,
    py: 0.25,
    borderRadius: 0.75,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      bgcolor: palette.grey.lightBackground,
    },
  },
  displayCellText: {
    fontSize: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  mutedText: {
    color: "text.secondary",
  },
  colorDisplaySwatch: {
    width: 16,
    height: 16,
    borderRadius: 0.5,
    border: "1px solid rgba(0,0,0,0.15)",
    flexShrink: 0,
  },
});

export function CompactDisplayColorCell({
  value,
  onClick,
  onColorChange,
  minWidth,
  maxWidth,
}: {
  value: string;
  onClick?: () => void;
  onColorChange?: (nextValue: string) => void;
  minWidth?: number;
  maxWidth?: number;
}) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const normalizedValue = value || "#000000";
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!onColorChange) {
      onClick?.();
      return;
    }

    setAnchorEl(open ? null : event.currentTarget);
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          ...styles.displayCellButton,
          ...(minWidth ? { minWidth } : null),
          ...(maxWidth ? { maxWidth, width: "100%" } : null),
        }}
      >
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Box
            sx={{ ...styles.colorDisplaySwatch, bgcolor: normalizedValue }}
          />
          <Typography
            variant="body2"
            sx={{
              ...styles.displayCellText,
              ...(value ? null : styles.mutedText),
            }}
          >
            {value || ""}
          </Typography>
        </Stack>
      </Box>
      {onColorChange ? (
        <ColorPicker
          isOpen={open}
          anchorEl={anchorEl}
          value={normalizedValue}
          onColorChange={onColorChange}
          onClose={() => setAnchorEl(null)}
          width="300px"
        />
      ) : null}
    </>
  );
}
